import { ChartTypeConfig } from './ChartTypeConfig';
import { SeriesType } from '../utils/SeriesType';
import { BasicChart, SeriesOption } from '../utils/models';

export class FunnelChartConfig implements ChartTypeConfig {
  getConfig(categories: string[], data: SeriesOption[], colors: string[]): Partial<BasicChart> {
    return {
      series: [{
        type: SeriesType.Funnel,
        data: categories.map((name, i) => ({ name, value: data[i] })),
        label: { formatter: '{b}: {c}%' }
      }],
      xAxis: undefined,
      yAxis: undefined,
      grid: undefined
    };
  }
}
